import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Box, Heading } from 'lucid-components-react';

import Link from 'components/link/link';
import {
  Drupal_FieldParagraphFlexiStyledMultiSectionsFieldSections,
  Drupal_ParagraphFlexiSection
} from 'generated/graphql';
import { getProcessedValue } from 'utils/helpers';
import { mqMin } from 'theme/base';
import { Text } from 'theme/typography';
import linkParser from 'utils/link-parser';

interface Props {
  entities: Drupal_FieldParagraphFlexiStyledMultiSectionsFieldSections[];
}

const FourAcross = ({ entities }: Props) => {
  return entities.map(({ entity }) => {
    const {
      fieldFlexiHeader,
      fieldFlexiBody,
      fieldFlexiImage,
      fieldFlexiLink
    } = entity as Drupal_ParagraphFlexiSection;

    return (
      <Box
        key={fieldFlexiHeader}
        css={{
          label: 'text',
          display: 'flex',
          flex: '0 1 100%',
          flexDirection: 'column',
          [mqMin.tabletLandscape]: {
            flex: '0 1 22%',
            maxWidth: '22%'
          }
        }}
        mb={8}
        mx={{ default: 'auto', tablet: 0 }}
        px={{ default: 6, tablet: 0 }}
      >
        <Box maxWidth="180px">
          <img alt={fieldFlexiHeader || ''} src={fieldFlexiImage || ''} />
        </Box>
        <Heading
          as="h4"
          css={{
            marginTop: 0,
            marginBottom: 0
          }}
          variant="subheadXXS700"
        >
          {fieldFlexiHeader}
        </Heading>
        <Text
          as="div"
          css={{
            marginTop: 0,
            marginBottom: 0
          }}
          textStyles="bodyS400"
        >
          {ReactHtmlParser(getProcessedValue(fieldFlexiBody), {
            transform: linkParser
          })}
        </Text>
        {fieldFlexiLink && fieldFlexiLink.url && fieldFlexiLink.title && (
          <Link primary to={fieldFlexiLink.url.path || ''}>
            {fieldFlexiLink.title}
          </Link>
        )}
      </Box>
    );
  });
};

export default FourAcross;
